angular.module('gym.membership-plans').controller('ManageMembershipPlanBookAndPayCtrl', ["$scope", "$rootScope", "$modalInstance", "$http", "plan", function($scope, $rootScope, $modalInstance, $http, plan) {
  var gym;
  gym = $rootScope.gym;
  $scope.plan = plan;
  $scope.save = function() {
    var url;
    $scope.isLoading = true;
    url = `/gyms/${gym.id}/membership_plans/${plan.id}`;
    return $http.put(url, {
      membership_plan: $scope.plan
    }).then(function() {
      return $modalInstance.close();
    }, function(response) {
      $scope.isLoading = false;
      return $scope.errors = response.data.errors;
    });
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
